var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"detail"}},[_c('p',[_vm._v(_vm._s(_vm.title[_vm.index].value))]),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.detail[_vm.title[_vm.index].key]))])])}
var staticRenderFns = []

export { render, staticRenderFns }